import { clone, lowerCase } from 'lodash';
import * as Constants from '../constants/Constants';
import moment from 'moment';
import '../utils/moment-extensions';

/**
 * @class TimesGridState
 */
export default class TimesGridState {
    /**
     * @constructor
     * @param {Array.<string>} doctorLocationIds
     * @param {object} state
     * @param {boolean} [state.isExistingPatient]
     * @param {boolean} [state.isReschedule]
     * @param {string} [state.referrerType]
     * @param {int} [state.availabilityTimeFilter]
     * @param {moment} [state.date]
     * @param {int} [state.numDaysVisible]
     * @param {string} [state.procedureId]
     * @param {boolean} [state.isMobile]
     * @param {string} [state.widget]
     * @param {string} [state.insuranceCarrier]
     * @param {string} [state.insurancePlan]
     * @param {string} [state.directoryId]
     * @param {string} [state.apikey]
     */
    constructor(doctorLocationIds, state) {
        this.availabilityTimeFilter = state.availabilityTimeFilter;
        this.directoryId = state.directoryId || '-1';
        this.doctorLocationIds = doctorLocationIds;
        this.gridType = state.isMobile ? Constants.TYPE.MOBILE : Constants.TYPE.DESKTOP;
        this.initialized = Boolean(state.bootstrappedNewPatientTimes && state.bootstrappedExistingPatientTimes);
        this.insuranceCarrier = state.insuranceCarrierId || '-1';
        this.insurancePlan = state.insurancePlanId || '-1';
        this.isExistingPatient = Boolean(state.isExistingPatient);
        this.isReschedule = Boolean(state.isReschedule);
        this.numDaysVisible = state.numDaysVisible || 5;
        this.procedureId = state.procedureId || '-1';
        this.referrerType = state.referrerType;
        this.widget = state.widget || (lowerCase(state.referrerType) === 'widget' ? true : '');
        this.apikey = state.apikey || '';

        this.date = this.parseDate(state.date);
        if (this.date.isBeforeToday()) {
            this.date = moment();
        }
    }

    parseDate(datePassedIn) {
        // moment v1 and moment v2 don't play nicely together

        let date = moment();
        if (datePassedIn && datePassedIn.format) {
            // attempt to get the date
            const stateDateStr = datePassedIn.format();
            const possibleDate = moment(stateDateStr);

            if (possibleDate.isValid()) {
                date = possibleDate;
            }
        }

        return date;
    }

    toJSON() {
        return clone(this);
    }
}
